export default "__VITE_ASSET__bff81de0__"